import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var OfficeBuildingIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M21.99 20.596h-1.05l-.05-8.66c0-1.29-1.05-2.34-2.34-2.34h-2.27c-.09 0-.17.02-.26.03v-2.83c0-1.19-.8-2.23-1.94-2.54l-7.87-2.16c-.8-.22-1.64-.06-2.29.45a2.62 2.62 0 00-1.04 2.1v15.95H2c-.55 0-1 .45-1 1s.45 1 1 1H22c.55 0 1-.45 1-1s-.45-1-1-1h-.01zm-5.7-9h2.27c.19 0 .34.15.34.34l.05 8.65h-2.92v-8.84c.06-.09.15-.15.26-.15zM5.03 4.646c0-.21.12-.33.19-.38a.47.47 0 01.42-.08l7.88 2.15c.21.06.36.25.36.47v13.8h-1.95c0-.05.03-.1.03-.15v-3.38c0-.81-.66-1.47-1.47-1.47H8.35c-.81 0-1.47.66-1.47 1.47v3.38c0 .05.02.1.03.15H5.03V4.646zm4.95 15.95H8.84c0-.05.03-.1.03-.15v-2.84h1.08v2.84c0 .05.02.1.03.15z"
                        }),
                        _jsx("path", {
                            d: "M7.95 9.596h3c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1zM7.95 13.596h3c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1z"
                        })
                    ]
                })
            })
        ]
    });
};
OfficeBuildingIcon.isCarinaIcon = true;
export default OfficeBuildingIcon;
